import { render } from "./MentorRadarView.vue?vue&type=template&id=63892cbb&scoped=true"
import script from "./MentorRadarView.vue?vue&type=script&lang=js"
export * from "./MentorRadarView.vue?vue&type=script&lang=js"

import "./MentorRadarView.vue?vue&type=style&index=0&id=63892cbb&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63892cbb"]])

export default __exports__